import React, { Fragment, useRef } from "react";
import _ from "lodash";
import RegisterFields from "../RegisterFields";
import techFormFields from "./techFormFields";
import {
  getTechnicianInitialValue,
  normalizeTechnicianRoles,
} from "./techFormUtils";

export const TechEditForm = ({ onChange, initailValues, onChecked }) => {
  const inputRef = useRef({});

  const renderFields = () => {
    const safeInitialValues = initailValues || {};
    const roleStatuses = normalizeTechnicianRoles(
      safeInitialValues.roles,
    ).map((item) => item.status);

    return _.map(techFormFields, ({ label, name, type, options, required }) => {
      return (
        <RegisterFields
          key={name || label}
          name={name}
          label={label}
          type={type}
          value={inputRef.current.name}
          options={options}
          required={required}
          initailValue={getTechnicianInitialValue(safeInitialValues, name)}
          disabled={name === "id" ? true : false}
          onChange={onChange(name)}
          checked={roleStatuses}
          onChecked={onChecked}
        />
      );
    });
  };

  return <Fragment>{renderFields()}</Fragment>;
};
